import { network } from 'services/network';

type param = number[];

export const deleteReportTags = (param: param) => {
    return network.post('api/bo/reporting/deleteTags', param).then((response) => {
        return response.data;
    });
};
